import React, { useState, useEffect } from 'react';

import { series } from 'utilities';

import application from 'application';
import internalEventCodes from 'event-system/codes/internal';

import './index.scss';

function OfflineView(props) {

  const [rootState, setRootState] = useState({
    disconnected: false,
    displayWillAttemptToReconnectMessage: false,
    displayConnectingMessage: false,
    willAttemptToReconnectMessage: '',
    willReconnect: false
  });

  useEffect(function registerForEvents() {

    const eventRegisterers = [
      registerWillAttemptToReconnectEventHandler,
      registerConnectedToServerEventHandler,
      registerDisconnectedFromServerEventHandler,
      registerConnectingToServerEventHandler
    ];

    return function unregisterEventHandlers() {
      series(eventRegisterers);
    };

  }, []);

  function getWillAttemptToReconnectMessage(data) {
    return `Connecting to server in ${data.willReconnectInSeconds} seconds...`;
  }

  function registerWillAttemptToReconnectEventHandler() {

    function willAttemptToReconnectEventHandler(data) {

      setRootState(function updateRootState(rootState) {
        return {
          ...rootState,
          displayWillAttemptToReconnectMessage: true,
          willAttemptToReconnectMessage: getWillAttemptToReconnectMessage(data),
          displayConnectingMessage: false,
          willReconnect: true
        };
      });

    }

    application.eventSystem.internal.on(internalEventCodes.WILL_ATTEMPT_TO_RECONNECT_TO_SERVER, willAttemptToReconnectEventHandler);

    return function unregisterWillAttemptToReconnectEventHandler() {
      application.eventSystem.internal.off(internalEventCodes.WILL_ATTEMPT_TO_RECONNECT_TO_SERVER, willAttemptToReconnectEventHandler);
    };

  }

  function registerDisconnectedFromServerEventHandler() {

    function disconnectedFromServerEventHandler(data) {

      setRootState(function updateRootState(rootState) {
        return {
          ...rootState,
          disconnected: true,
          displayWillAttemptToReconnectMessage: data.willReconnect,
          willAttemptToReconnectMessage: getWillAttemptToReconnectMessage(data),
          displayConnectingMessage: false,
          willReconnect: data.willReconnect
        };
      });

    }

    application.eventSystem.internal.on(internalEventCodes.DISCONNECTED_FROM_SERVER, disconnectedFromServerEventHandler);

    return function unregisterDisconnectedFromServerEventHandler() {
      application.eventSystem.internal.off(internalEventCodes.DISCONNECTED_FROM_SERVER, disconnectedFromServerEventHandler);
    };

  }

  function registerConnectedToServerEventHandler() {

    function connectedToServerEventHandler(data) {

      setRootState(function updateRootState(rootState) {
        return {
          ...rootState,
          disconnected: false,
          displayConnectingMessage: false,
          displayWillAttemptToReconnectMessage: false,
          willReconnect: false
        };
      });

    }

    application.eventSystem.internal.on(internalEventCodes.CONNECTED_TO_SERVER, connectedToServerEventHandler);

    return function unregisterConnectedToServerEventHandler() {
      application.eventSystem.internal.off(internalEventCodes.CONNECTED_TO_SERVER, connectedToServerEventHandler);
    };

  }

  function registerConnectingToServerEventHandler() {

    function connectingToServerEventHandler(data) {

      setRootState(function updateRootState(rootState) {
        return {
          ...rootState,
          displayConnectingMessage: true,
          displayWillAttemptToReconnectMessage: false
        };
      });

    }

    application.eventSystem.internal.on(internalEventCodes.CONNECTING_TO_SERVER, connectingToServerEventHandler);

    return function unregisterConnectingToServerEventHandler() {
      application.eventSystem.internal.off(internalEventCodes.CONNECTING_TO_SERVER, connectingToServerEventHandler);
    };

  }

  async function handleConnectButtonClick() {

    application.eventSystem.establishServerConnection();
    application.eventSystem.authenticate(application.authorizationToken);

  }

  function renderWillAttemptToReconnectMessage() {

    if (rootState.displayWillAttemptToReconnectMessage === false) {
      return;
    }

    return <div id="will-attempt-to-reconnect-message">
      {rootState.willAttemptToReconnectMessage}
    </div>;

  }

  function renderConnectingMessage() {

    if (rootState.displayConnectingMessage === false) {
      return;
    }

    return <div id="connecting-message">Connecting...</div>;

  }

  function renderConnectButton() {

    if (rootState.willReconnect === true) {
      return;
    }

    const connectButtonAttributes = {
      className: 'startup-themed-button reconnect-button',
      onClick() {
        handleConnectButtonClick();
      }
    };

    return <button {...connectButtonAttributes}>Connect</button>;

  }

  function renderDisconnectedStatus() {

    if (rootState.disconnected === false) {
      return;
    }

    return <div id="disconnected-view-main">

      {renderWillAttemptToReconnectMessage()}
      {renderConnectingMessage()}
      {renderConnectButton()}

    </div>;

  }

  function renderMain() {

    return <div id="offline-view-main">
      {renderDisconnectedStatus()}
    </div>;

  }

  return renderMain();

}

export default OfflineView;